<template>
  <div class="home" :style="`height: ${screenHeight}px;`">
    <!-- Canvas元素 -->
    <canvas ref="imageCanvas" class="image-canvas" @touchstart="onMove" @touchmove="onMove" @touchend="onMove">
      您的浏览器不支持canvas元素
    </canvas>
    <!-- 无数据 -->

    <van-empty v-if="newTtl > 0 && newList.length == 0" class="no-data" image="https://xhdata.wan4.com/wsw-h5-26.png"
      description="暂时没有新品视频可以生成了～">
    </van-empty>
    <van-empty v-else-if="newTtl <= 0" class="no-data" image="http://xhdata.wan4.com/wsw-h5-26.png"
      description="今天还没有新品哦～">
    </van-empty>

    <van-empty v-else-if="bjIndex < 0" class="no-data" image="https://xhdata.wan4.com/wsw-h5-26.png"
      description="所有商品背景组合都被其它人占用咯，等1分钟后在来吧～">
    </van-empty>


    <div class="btn-box" :style="`width: ${screenWidth}px;`" v-else>
      <van-button type="plain" @click="onSwitchBj">切换背景</van-button>
      <van-button type="plain" @click="onSwitchGoods">切换商品</van-button>
      <van-button type="primary" @click="startAnimation">开始录屏</van-button>
    </div>
    <span class="texzt">file</span>
    <audio id="beep" src="@/assets/audio/metal_spin_slowdown.wav"></audio>

  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      canvas: null,
      ctx: null,
      newTtl: 0,
      imgIndex: 0,

      numberList: [],
      duration: 6070, // 动画持续时间
      targetDigit: 5,
      audioCtx: null,
      sourceNode: null,

      newList: [],//今日新品列表
      finishGoodsIdList: [],// 已经生成完视频的商品ID记录列表
      goodsList: [],//全部商品列表
      goodsIndex: -1,//商品下标
      bjIndex: 0,//背景下标
      allBjList: [
        {
          type: 0,//0未使用，1 已使用
          bjImg: 'bj1.png',
          dayColor: '#848484',
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj2.png',
          dayColor: '#FFF2B4'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj3.png',
          dayColor: '#37FFF5'
        },
        {
          type: 0,//0未使用，1 已使用
          bjImg: 'bj4.png',
          dayColor: '#FFF312'
        },
        {
          type: 0,//0未使用，1 已使用
          bjImg: 'bj5.png',
          dayColor: '#F63'
        },
        {
          type: 0,//0未使用，1 已使用
          bjImg: 'bj6.png',
          dayColor: '#B671FF'
        },
        {
          type: 0,//0未使用，1 已使用
          bjImg: 'bj7.png',
          dayColor: '#FF37F5'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj8.png',
          dayColor: '#FF9D41'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj9.png',
          dayColor: '#5DFF00'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj10.png',
          dayColor: '#09F'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj11.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj12.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj13.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj14.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj15.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj16.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj17.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj18.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj19.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj20.png',
          dayColor: '#ffffff6d'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj21.png',
          dayColor: '#A06A44'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj22.png',
          dayColor: '#D15775'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj23.png',
          dayColor: '#C59846'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj24.png',
          dayColor: '#509690'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj26.png',
          dayColor: '#C56F7C'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj27.png',
          dayColor: '#E69A5C'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj28.png',
          dayColor: '#595C90'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj29.png',
          dayColor: '#4C7D85'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj30.png',
          dayColor: '#693C4B'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj31.png',
          dayColor: '#4F7E72'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj32.png',
          dayColor: '#875B89'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj33.png',
          dayColor: '#9D7456'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj34.png',
          dayColor: '#C44A59'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj35.png',
          dayColor: '#9D7456'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj36.png',
          dayColor: '#C96674'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj37.png',
          dayColor: '#B29748'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj38.png',
          dayColor: '#AB7AAF'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj39.png',
          dayColor: '#5BA9A2'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj40.png',
          dayColor: '#686189'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj41.png',
          dayColor: '#4A1F3B'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj42.png',
          dayColor: '#2B4664'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj43.png',
          dayColor: '#BF6461'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj44.png',
          dayColor: '#AB7A90'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj45.png',
          dayColor: '#C1956D'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj46.png',
          dayColor: '#6A6CA3'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj47.png',
          dayColor: '#64A296'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj48.png',
          dayColor: '#C46981'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj49.png',
          dayColor: '#BBA26F'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj50.png',
          dayColor: '#56577B'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj51.png',
          dayColor: '#97655D'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj52.png',
          dayColor: '#4F8480'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj53.png',
          dayColor: '#64A296'
        },
        {
          type: 0,//0未使用，1已使用
          bjImg: 'bj54.png',
          dayColor: '#734276'
        },
        
      ],
      listSize: 23,
      bjList: [
        {
          bjImg: '@/assets/icon/bj1.png',
          dayColor: '#848484'
        }
      ],
      dayTiem: 0,//当天时间
      bjCache: [],
      mimeType: '',//视频格式
    }
  },
  mounted() {
    this.dayTiem = new Date().setHours(0, 0, 0, 0);
    this.screenWidth = window.innerWidth < (750 / 2) ? window.innerWidth : (750 / 2);
    this.screenHeight = this.initSize(1624)
    // 获取canvas元素和绘图上下文
    const { canvas, ctx } = this.createHiDPICanvas(this.screenWidth, this.initSize(1624));
    this.canvas = canvas;
    this.ctx = ctx;
    // 启用抗锯齿并设置高质量
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = "high";
    this.getData();
    this.$nextTick(() => {
      const audioEl = document.getElementById("beep");
      this.audioCtx = new AudioContext();
      this.sourceNode = this.audioCtx.createMediaElementSource(audioEl);
    });
    // 预加载背景图片资源
    // this.preloadBjImg();
  },
  methods: {
    /**
    * 创建一个适配高清屏的 Canvas
    * @param {Number} width 逻辑宽度
    * @param {Number} height 逻辑高度
    * @param {HTMLElement} container 容器元素，可选
    * @returns {Object} { canvas, ctx, ratio }
    */
    createHiDPICanvas(width, height, container) {
      const dpr = window.devicePixelRatio || 1;

      const canvas = this.$refs.imageCanvas;
      const ctx = canvas.getContext("2d");

      // 设置实际像素大小
      canvas.width = width * dpr;
      canvas.height = height * dpr;

      // 样式大小还是逻辑大小
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      // 缩放
      ctx.scale(dpr, dpr);

      // 如果传入了容器，自动 append
      if (container) {
        container.appendChild(canvas);
      }

      return { canvas, ctx, ratio: dpr };
    },
    // 获取背景图片资源
    async preloadBjImg() {
      const icons = require.context('@/assets/bj', false, /\.png$/);
      const tasks = icons.keys().map(async key => {
        const src = icons(key);
        const img = await this.preloadImage(src);
        return [key.replace('./', ''), img];
      });
      this.bjCache = Object.fromEntries(await Promise.all(tasks));
    },
    preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
    async getData() {
      const [goodsData, cacheData] = await Promise.all([
        this.$ajax('/iap-api/pweb/csite/newList.do', { nowdt: this.dayTiem, size: this.listSize }),
        this.$ajax('/iap-api/getSelfDefinedDataCache2.do', { tempId: this.dayTiem, resall: true }),
      ]);
      const list = goodsData.data.newList || [];
      if (list.length < this.listSize) {
        for (let i = list.length; i < this.listSize; i++) {
          list.push(JSON.parse(JSON.stringify(list[this.getRandomNumber(goodsData.data.ndTtlToday, list.length - 1)])))
        }
      }

      this.goodsList = [
        ...list.filter(e => e.isDay != 1),
        ...list.filter(e => e.isDay == 1)
      ]

      this.newTtl = goodsData.data.ndTtlToday;
      if (this.newTtl <= 0) {
        return
      }
      if (cacheData.meta.res == '00000') {
        this.finishGoodsIdList = cacheData.data.list || [];
      } else {
        this.finishGoodsIdList = []
      }

      //过滤出今日新品列表
      this.newList = list.filter((e) => e.isDay == 1 && this.finishGoodsIdList.indexOf(e.poId) < 0);
      if (this.newList.length == 0) {
        return
      }

      //随机获取商品
      this.goodsIndex = this.getRandomNumber(0, this.newList.length - 1)
      this.bjList = await this.getBjList(this.newList[this.goodsIndex].poId);
      this.bjIndex = this.getRandomNumber(0, this.bjList.length - 1)

      this.drawImage();
    },
    initData() {
      this.screenHeight = this.initSize(1624);
      let arr1 = Array.from(String(this.goodsIndex + 1));
      var arrLength = arr1.length;
      //补充位置，最少3个数字
      if (arrLength < 3) {
        for (let i = 0; i < 3 - arrLength; i++) {
          arr1.unshift('0');
        }
      }
      // 初始化数字位置
      const numberWidth = this.initSize(70);
      const numberHeight = this.initSize(108);
      const offsetLeft = this.initSize(20);
      const x = (this.screenWidth - numberWidth * 3 - (offsetLeft * 2)) / 2;
      const y = this.initSize(520);
      this.numberList = [];
      arr1.forEach((num, index) => {
        this.numberList.push({
          value: parseInt(num),
          x: x + (numberWidth + offsetLeft) * index,
          y: y,
          w: numberWidth,
          h: numberHeight,
          time: this.duration - ((arr1.length - index) * 500),
          totalRounds: 8,
          // 需要滚动的总距离（多圈 + 最终目标）
          totalDistance: (8 * 10 + parseInt(num)) * numberHeight
        });
      });
    },


    // 获取指定范围内的随机整数（包括最小值和最大值）
    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    //切换商品
    async onSwitchGoods() {
      if (this.newList.length == 1) {
        this.$toastUtil.show('暂无其它新品')
        return
      }
      let nextIndex = this.goodsIndex + 1;
      if (nextIndex == this.newList.length) {
        nextIndex = 0;
      }
      this.goodsIndex = nextIndex;
      this.bjList = await this.getBjList(this.newList[this.goodsIndex].poId);
      this.bjIndex = this.getRandomNumber(0, this.bjList.length - 1)
      this.drawImage();
    },
    initGoodsList() {
      this.goodsList = [
        ...this.goodsList.filter(e => e.poId != this.newList[this.goodsIndex].poId),
        ...this.goodsList.filter(e => e.poId == this.newList[this.goodsIndex].poId)
      ]


    },
    //切换背景
    async onSwitchBj() {
      if (this.bjList.length == 1) {
        this.$toastUtil.show('暂无其它背景')
        return
      }
      let nextIndex = this.bjIndex + 1;
      if (nextIndex == this.bjList.length) {
        nextIndex = 0;
      }
      this.bjIndex = nextIndex;
      console.log(nextIndex);
      
      this.drawImage();
    },
    async getBjList(tempId) {
      let res = await this.$ajax('/iap-api/getSelfDefinedDataCache2.do', { tempId: tempId + this.dayTiem, resall: true });
      let list = [];
      if (res.meta.res == '00000') {
        list = res.data.list || [];
      } else {
        list = JSON.parse(JSON.stringify(this.allBjList));
      }
      return list.filter(e => e.type == 0)
    },
    // po-6c5a80104c0548428d7061ac7676f29510

    setGoodsData(tempId, list, fn) {
      this.$ajax('/iap-api/setSelfDefinedDataCache2.do', { tempId: tempId + this.dayTiem, myData: { list } }).then(() => {
        fn && fn();
      })
    },

    /**
     * 绘制图片到canvas
     */
    drawImage() {
      this.initData();
      // 创建图片对象
      this.clearCanvas();

      let initDraw = (bjSrc) => {
        // 绘制图片
        this.ctx.drawImage(bjSrc, 0, 0, this.screenWidth, this.screenHeight);

        this.drawDailyNewDesigns()
        // 绘制文字
        this.drawText(this.getCurrentMonthInEnglish() + ' ' + new Date().getDate(), this.screenWidth / 2, this.initSize(400), 64, this.bjList[this.bjIndex].dayColor, 'size "poller one"')
        this.drawText('(' + this.newTtl + ')', this.screenWidth / 2, this.initSize(460), 40, '#FFF', 'bold size "PingFang SC"')

        // 绘制数字翻页效果
        this.drawFlipNumbers();

        // 绘制戒指
        this.initDrawRings();

        // 添加网站链接
        this.addWebsiteLink();
      }
      //有缓存 直接用缓存
      if (this.bjCache[`${this.bjList[this.bjIndex].bjImg}`]) {
        initDraw(this.bjCache[`${this.bjList[this.bjIndex].bjImg}`]);
      } else {
        const icons = require.context('@/assets/bj', false, /\.png$/);
        const ringImg = new Image();
        ringImg.crossOrigin = "Anonymous";
        ringImg.src = icons(`./${this.bjList[this.bjIndex].bjImg}`);
        ringImg.onload = () => {
          this.bjCache[`${this.bjList[this.bjIndex].bjImg}`] = ringImg;
          initDraw(ringImg);
        }
      }
    },

    drawDailyNewDesigns() {
      const ringImg = new Image();
      ringImg.crossOrigin = 'Anonymous';
      ringImg.src = require('@/assets/icon/daily-new-designs.png');
      ringImg.onload = () => {
        this.ctx.save();
        this.ctx.drawImage(ringImg, (this.screenWidth - this.initSize(370)) / 2, this.initSize(294), this.initSize(370), this.initSize(48));
        this.ctx.restore();
      };
    },
    drawText(value, x, y, size, color, font) {
      this.ctx.save();
      this.ctx.font = font.replace('size', this.initSize(size) + 'px')
      this.ctx.fillStyle = color;
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = "middle";
      this.ctx.fillText(value, x, y);
      this.ctx.restore();
    },
    drawFlipNumbers() {
      this.numberList.forEach((numItem) => {
        this.drawDigits(Number(numItem.value) * numItem.h, numItem);
      });
    },
    drawStyledBox(ctx, x, y, w, h) {
      ctx.save();

      // 背景渐变
      const gradient = ctx.createLinearGradient(x, y, x, y + h);
      gradient.addColorStop(0, "#333");
      gradient.addColorStop(0.5241, "#666");
      gradient.addColorStop(1, "#333");

      // ---- 模拟 inset 阴影 ----
      // 思路：先画一个黑色区域，再用渐变透明遮罩
      ctx.fillStyle = gradient;
      this.roundRect(ctx, x, y, w, h, this.initSize(10));
      ctx.fill();


      // 内阴影 (inset) 模拟：用阴影叠加透明路径
      ctx.clip(); // 限制在矩形内
      ctx.shadowColor = "rgba(0,0,0,0.85)";
      ctx.shadowBlur = 6;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 4;
      ctx.fillStyle = gradient;
      ctx.fillRect(x, y, w, h);

      // 边框
      ctx.lineWidth = this.initSize(4);
      ctx.strokeStyle = "#FFF";
      ctx.stroke();

      ctx.restore();
    },
    drawNumber(value, x, y, w, h) {
      this.ctx.save();
      this.ctx.font = 'bold ' + this.initSize(80) + 'px "PingFang SC"';
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'alphabetic';

      const metrics = this.ctx.measureText(value);
      const actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;

      const centerY = y + (h / 2) + (actualHeight / 2 - metrics.actualBoundingBoxDescent);

      this.ctx.fillText(value, x + (w / 2), centerY);
      this.ctx.restore();
    },
    initDrawRings() {
      const ringWidth = this.initSize(500);
      const ringHeight = this.initSize(500);
      const x = (this.screenWidth - ringWidth) / 2;
      const y = this.initSize(670);
      let loadCount = 0;

      // === 新的时序分配 ===
      this.initGoodsList();
      const schedule = this.distributeDurationsOverlap(5000, this.goodsList.length, 800);


      for (let i = this.imgIndex; i < this.goodsList.length; i++) {
        const ringImg = new Image();
        ringImg.crossOrigin = 'Anonymous';
        ringImg.src = this.goodsList[i].url;
        this.goodsList[i].x = x;
        this.goodsList[i].y = y;
        this.goodsList[i].width = ringWidth;
        this.goodsList[i].height = ringHeight;
        this.goodsList[i].ringImg = ringImg;

        this.goodsList[i].startY = y - this.goodsList[i].height; // 初始位置在画布外
        this.goodsList[i].endY = y; // 目标位置在画布内

        // ✅ 使用分配好的 startTime / duration
        this.goodsList[i].startTime = schedule[i].startTime;
        this.goodsList[i].duration = schedule[i].duration;
        ringImg.onload = () => {
          loadCount++;
          if (loadCount === this.goodsList.length) {
            this.drawRoundImage(this.newList[this.goodsIndex].ringImg, x, y, ringWidth, ringHeight, this.initSize(20));
          }
        };
      }
    },
    distributeDurationsOverlap(
      totalTime,
      imgSize,
      lastDur = 700,
      overlap = 1 / 3,
      k = 2,
      minDur = 300
    ) {
      console.log(totalTime, imgSize, lastDur, overlap, k, minDur);


      return [
        {
          "startTime": 0,
          "duration": 600
        },
        {
          "startTime": 200,
          "duration": 600
        },
        {
          "startTime": 400,
          "duration": 600
        },
        {
          "startTime": 600,
          "duration": 600
        },
        {
          "startTime": 800,
          "duration": 600
        },
        {
          "startTime": 1000,
          "duration": 600
        },
        {
          "startTime": 1200,
          "duration": 600
        },
        {
          "startTime": 1400,
          "duration": 600
        },
        {
          "startTime": 1600,
          "duration": 600
        },
        {
          "startTime": 1800,
          "duration": 600
        },
        {
          "startTime": 2000,
          "duration": 600
        },
        {
          "startTime": 2200,
          "duration": 600
        },
        {
          "startTime": 2400,
          "duration": 600
        },
        {
          "startTime": 2600,
          "duration": 600
        },
        {
          "startTime": 2800,
          "duration": 600
        },
        {
          "startTime": 3000,
          "duration": 600
        },
        {
          "startTime": 3200,
          "duration": 600
        },
        {
          "startTime": 3400,
          "duration": 600
        },
        {
          "startTime": 3600,
          "duration": 600
        },
        {
          "startTime": 3800,
          "duration": 600
        },
        {
          "startTime": 4000,
          "duration": 600
        },
        {
          "startTime": 4200,
          "duration": 600
        },
        {
          "startTime": 4400,
          "duration": 600
        }
      ]

    }
    ,
    // distributeDurationsOverlap(totalTime, imgSize, lastDur = 800, overlap = 1 / 3, k = 2) {
    //   if (imgSize <= 0) return [];
    //   if (totalTime <= 0) return [];
    //   if (lastDur >= totalTime) {
    //     return [{ startTime: 0, duration: totalTime }];
    //   }
    //   if (!(overlap > 0 && overlap <= 1)) {
    //     overlap = Math.min(Math.max(overlap, 0.01), 1);
    //   }
    //   const N = imgSize;
    //   if (N === 1) {
    //     return [{ startTime: 0, duration: totalTime }];
    //   }
    //   const remain = totalTime - lastDur;
    //   const nDelta = N - 1;

    //   // 权重分配 delta
    //   const weights = new Array(nDelta);
    //   for (let i = 0; i < nDelta; i++) {
    //     weights[i] = Math.pow(i + 1, k);
    //   }
    //   const sumW = weights.reduce((s, v) => s + v, 0);
    //   const deltas = weights.map(w => (w / sumW) * remain);

    //   // 计算 startTime / duration
    //   const result = new Array(N);
    //   let curStart = 0;
    //   for (let i = 0; i < N; i++) {
    //     if (i < N - 1) {
    //       const delta = deltas[i];
    //       const duration = delta / overlap; // 保证交错
    //       result[i] = { startTime: curStart, duration: duration };
    //       curStart = curStart + delta;
    //     } else {
    //       result[i] = { startTime: curStart, duration: lastDur };
    //       curStart = curStart + lastDur;
    //     }
    //   }

    //   // 修正最后结束时间 = totalTime
    //   const finalFinish = result[N - 1].startTime + result[N - 1].duration;
    //   const diff = totalTime - finalFinish;
    //   if (Math.abs(diff) > 1e-6) {
    //     result[N - 1].startTime += diff;
    //     if (result[N - 1].startTime < 0) result[N - 1].startTime = 0;
    //   }

    //   return result;
    // },


    drawRoundImage(img, x, y, width, height, radius) {

      // ---- 阴影设置 ----
      // this.ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
      // this.ctx.shadowBlur = 15;
      // this.ctx.shadowOffsetX = 0;
      // this.ctx.shadowOffsetY = 6;


      this.ctx.save();
      // 创建圆角路径
      this.ctx.beginPath();
      this.ctx.moveTo(x + radius, y);
      this.ctx.lineTo(x + width - radius, y);
      this.ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      this.ctx.lineTo(x + width, y + height - radius);
      this.ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      this.ctx.lineTo(x + radius, y + height);
      this.ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      this.ctx.lineTo(x, y + radius);
      this.ctx.quadraticCurveTo(x, y, x + radius, y);
      this.ctx.closePath();

      // ---- 阴影会跟着路径一起绘制 ----
      this.ctx.fillStyle = '#fff';
      this.ctx.fill(); // 先填充背景，这一步的 fill 会生成阴影

      // ---- 关闭阴影后再绘制图片（避免图片被模糊）----
      this.ctx.shadowColor = 'transparent';
      this.ctx.shadowBlur = 0;
      this.ctx.shadowOffsetX = 0;
      this.ctx.shadowOffsetY = 0;

      this.ctx.clip(); // 裁剪路径
      this.ctx.drawImage(img, x, y, width, height);

      this.ctx.restore();
    },

    initSize(size) {
      this.ratio = this.screenWidth / 750;
      return size * this.ratio;
    },
    addWebsiteLink() {
      const ringImg = new Image();
      ringImg.crossOrigin = 'Anonymous';
      ringImg.src = require('@/assets/icon/wan4-icon.png');
      ringImg.onload = () => {
        this.ctx.save();
        this.ctx.drawImage(ringImg, (this.screenWidth - this.initSize(413)) / 2, this.initSize(1190), this.initSize(413), this.initSize(113));
        this.ctx.restore();
      };
    },

    /**
     * 清空画布
     */
    clearCanvas() {
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    },


    // 获取当前月份的英文缩写
    getCurrentMonthInEnglish() {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const date = new Date();
      const monthIndex = date.getMonth(); // getMonth() 返回的月份是从0开始的（0代表1月，11代表12月）
      return months[monthIndex];
    },


    /**
     * 绘制占位符（当图片加载失败时）
     */
    drawPlaceholder(errorText) {
      // 绘制背景
      this.ctx.fillStyle = '#f0f0f0';
      this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);

      // 绘制边框
      this.ctx.strokeStyle = '#ccc';
      this.ctx.lineWidth = 2;
      this.ctx.strokeRect(0, 0, this.canvas.width, this.canvas.height);

      // 绘制提示文字
      this.ctx.fillStyle = '#999';
      this.ctx.font = '16px Arial';
      this.ctx.textAlign = 'center';
      this.ctx.textBaseline = 'middle';
      this.ctx.fillText(errorText, this.canvas.width / 2, this.canvas.height / 2);
    },

    // 鼠标移动时阻止默认行为
    onMove(e) {
      e.preventDefault();
    },

    startAnimation() {
      let startTime = Date.now();

      this.startRecording();
      let animate = () => {
        const elapsed = Date.now() - startTime;

        this.goodsList.forEach((item) => {
          if (elapsed < item.startTime || item.startTime + item.duration < elapsed) {
            return
          }
          const t = Math.min((elapsed - item.startTime) / item.duration, 1);
          const eased = this.easeOutCubic(t);
          const y = item.startY + (item.endY - item.startY) * eased;
          this.drawImageCard(item.ringImg, item, y);
        });
        this.numberList.forEach((numItem) => {
          if (elapsed > numItem.time) {
            return
          }
          const t = Math.min(elapsed / numItem.time, 1); // 归一化 0~1
          const progress = this.easeOutCubic(t);
          // 当前偏移量（负数表示往上滚）
          let offsetY = (progress * numItem.totalDistance) % ((10 * numItem.h));
          this.drawDigits(offsetY, numItem);
        });
        if (elapsed < this.duration) {
          requestAnimationFrame(animate);
        } else {
          // 动画完成时，强制对齐目标数字，避免小数误差
          this.numberList.forEach((numItem) => {
            const finalOffset = (numItem.value * numItem.h);
            this.drawDigits(finalOffset, numItem);
          });
          setTimeout(() => { this.startZoom() }, 200)
        }
      }
      requestAnimationFrame(animate);
    },

    drawDigits(offsetY, numItem) {
      let ctx = this.ctx;
      ctx.save(); // 保存当前状态

      // 限定绘制区域
      ctx.beginPath();
      ctx.rect(numItem.x, numItem.y, numItem.w, numItem.h);
      ctx.clip();
      // 清理当前数字区域，避免重叠
      this.drawStyledBox(this.ctx, numItem.x, numItem.y, numItem.w, numItem.h)


      // 设置字体
      ctx.font = "bold 80px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "#FFF"; // 字体颜色


      // 多画几圈，保证连续性
      for (let i = -1; i <= 11; i++) {
        const num = (i + 10) % 10; // 0~9 循环
        const y = -(i * numItem.h) + offsetY;
        this.drawNumber(num, numItem.x, y + numItem.y, numItem.w, numItem.h);
      }
      ctx.restore(); // 恢复，保证不影响其他绘制
    },

    // 缓动函数 easeOutCubic (先快后慢)
    easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    },
    drawImageCard(img, item, y) {
      let h = item.height;
      let w = item.width;
      let x = item.x;

      this.ctx.save();

      // 限定绘制区域
      this.roundRect(this.ctx, x, item.y, w, h, this.initSize(20));
      this.ctx.clip();

      // 绘制图片
      this.ctx.drawImage(img, x, y, w, h);
      // 绘制边框
      // this.ctx.save();
      // this.roundRect(this.ctx, x, y, w, h, this.initSize(20));
      // this.ctx.strokeStyle = '#A7A6A6';
      // this.ctx.lineWidth = 1;
      // this.ctx.stroke();
      this.ctx.restore();
    },
    // 画圆角矩形路径
    roundRect(ctx, x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    },

    //放大动画
    // 替换或新增到 methods 中
    startZoom() {
      // 放大目标（最后一张）
      const item = this.goodsList[this.goodsList.length - 1];
      if (!item || !item.ringImg) return;

      const targetScale = this.screenWidth / item.width;    // 最终放大到 1.2

      const duration = 1000;      // 放大用时 1s（你可以改）
      const startTime = performance.now();
      const self = this;

      function animate(now) {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        const progress = self.easeOutCubic(t);
        const scale = 1 + (targetScale - 1) * progress; // 从 1 -> 1.2

        // 然后绘制放大的那张图
        self.drawScaledItem(item, scale);

        if (t < 1) {
          requestAnimationFrame(animate);
        } else {
          // 动画结束时确保精确到 targetScale
          self.drawScaledItem(item, targetScale);
          self.stopRecording();
        }
      }
      requestAnimationFrame(animate);
    },

    // 新增 helper：以图片中心缩放并圆角裁剪后绘制
    drawScaledItem(item, scale) {
      const ctx = this.ctx;
      const w = item.width;
      const h = item.height;
      const x = item.x;
      const y = item.y;
      const radius = this.initSize(20);

      // 缩放后的尺寸
      const sw = w * scale;
      const sh = h * scale;

      // 保持中心缩放：重新计算缩放后左上角
      const dx = x + (w - sw) / 2;
      const dy = y + (h - sh) / 2;

      ctx.save();

      // 圆角裁剪区域（缩放后的）
      this.roundRect(ctx, dx, dy, sw, sh, radius);
      ctx.clip();

      // 绘制图片
      ctx.drawImage(item.ringImg, dx, dy, sw, sh);

      ctx.restore();
    },
    async startRecording() {
      const canvasStream = this.canvas.captureStream(60); // 60fps

      const audioEl = document.getElementById("beep");

      // 确保 AudioContext 只初始化一次
      if (!this.audioCtx) {
        this.audioCtx = new AudioContext();
        this.sourceNode = this.audioCtx.createMediaElementSource(audioEl);
      }

      if (this.audioCtx.state === "suspended") {
        await this.audioCtx.resume();
      }

      const dest = this.audioCtx.createMediaStreamDestination();

      // 关键：既要连到扬声器，又要连到录制流
      this.sourceNode.connect(this.audioCtx.destination);
      this.sourceNode.connect(dest);

      // 合并音频 + 视频轨道
      const combinedStream = new MediaStream([
        ...canvasStream.getTracks(),
        ...dest.stream.getTracks()
      ]);

      this.recorderChunks = [];
      // 检测支持的 mimeType
      let mimeType = "";
      if (MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")) {
        mimeType = "video/webm;codecs=vp9,opus";
      } else if (MediaRecorder.isTypeSupported("video/webm;codecs=vp8,opus")) {
        mimeType = "video/webm;codecs=vp8,opus";
      } else if (MediaRecorder.isTypeSupported("video/mp4")) {
        // ⚠️ iOS Safari 通常只支持 mp4，但部分版本完全不支持 MediaRecorder
        mimeType = "video/mp4";
      } else {
        mimeType = "";
      }
      this.recorder = new MediaRecorder(combinedStream, {
        mimeType,
      });
      this.mimeType = mimeType;


      this.recorder.ondataavailable = e => {
        if (e.data.size > 0) this.recorderChunks.push(e.data);
      };

      this.recorder.onstop = () => {
        this.$dialog.confirm({
          title: `视频生成完成`,
          message: `如果感觉有卡顿，请重新录制\n(如果生成的是webm视频文件，可以百度webm 转 mp4)`,
          confirmButtonText: '下载'
        }).then(() => {
          this.downloadAideo();
        }).catch(() => {
          this.drawImage();
        });
      };
      this.recorder.start();
      // 播放音频
      audioEl.currentTime = 0;
      audioEl.play();
    },
    stopRecording() {
      if (this.recorder && this.recorder.state !== "inactive") {
        this.recorder.stop();
      }
    },
    //检查数据是否过期
    async checkData(fn) {
      //获取数据时间和当前时间不一样，数据失效
      if (this.dayTiem != new Date().setHours(0, 0, 0, 0)) {
        this.$dialog.alert({
          message: `数据失效`
        }).then(() => {
          // 刷新当前页面
          window.location.reload();
        })
      }
      //获取最新的背景数据
      const list = await this.getBjList(this.newList[this.goodsIndex].poId);
      let bjImg = this.bjList[this.bjIndex].bjImg;
      //根据图片找最新的背景列表 有表示还没有人用
      if (list.filter(e => e.bjImg == bjImg).length > 0) {
        //去掉要用的
        let newList = list.filter(e => e.bjImg != bjImg);
        //如果列表里没有了 说明背景被用完了，把这个视频加入到失效新品列表
        if (newList.length == 0) {
          this.updateFinishGoodsIdList(this.newList[this.goodsIndex].poId);
        }
        //更新数据
        this.setGoodsData(this.newList[this.goodsIndex].poId, newList, () => {
          fn && fn();
        })
      } else {
        //没有提示已尽被下载使用了
        this.$dialog.alert({
          message: `此视频已被抢先录制过了哦！`
        }).then(() => {
          // 刷新当前页面
          window.location.reload();
        })
      }
    },
    async updateFinishGoodsIdList(id) {
      let res = await this.$ajax('/iap-api/getSelfDefinedDataCache2.do', { tempId: this.dayTiem, resall: true });
      let list = res.data.list || [];
      list.push(id);
      this.setGoodsData('', list)
    },
    //下载视频
    async downloadAideo() {
      // 检测 blob 类型
      const blob = new Blob(this.recorderChunks, { type: this.mimeType });
      const type = this.getFileType(blob);
      if (!type) {
        this.$dialog.alert({
          message: `视频文件格式未知，请更换手机录制`
        }).then(() => {
          // 刷新当前页面
          window.location.reload();
        })
        return
      }
      this.checkData(async () => {
        let url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = this.getFileName(type);
        a.click();
      })
    },

    getFileName(type) {
      const dateObj = new Date();
      const year = dateObj.getFullYear(); // 获取当前年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取当前月份，其中需要将月份加1，因为月份是从0开始计数的
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取当前日期
      const formattedDate = `${year}-${month}-${day}`; // 格式化日期
      return `${formattedDate}_${Date.now()}.${type}`
    },
    getFileType(blob) {
      if (!blob || !blob.type) return "unknown";
      if (blob.type.includes("webm")) return "webm";
      if (blob.type.includes("mp4")) return "mp4";
      return "unknown";
    }

  }
}
</script>

<style scoped>
.home {
  padding: 0;
  text-align: center;
  overflow: hidden;
  position: relative;
  margin: auto;
}

.image-canvas {
  border: none;
  display: block;
  margin: 0 auto;
}

.btn-box {
  position: fixed;
  bottom: 0px;
  display: flex;
  background: #fff;
  padding: 20px;

  >button {
    flex: 1;
    font-size: 28px;
    height: 80px;
    margin: 0 12px;
    border-radius: 8px;
  }
}

.no-data {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}

.texzt {
  font-family: Poller One;
  font-size: 0px;
}
</style>